import { Button, Modal } from "react-bootstrap";

import { formatCalendarDate } from "../../../Utils/helper";

const PreviewCase = ({ caseData }) => (
  <span>
    {caseData.file_number
      ? `File #${caseData.file_number}`
      : `Case #${caseData.id} (no file number)`}
    {caseData.case_type ? ` (${caseData.case_type})` : ""}
    {caseData.incident_date ? ` · ${formatCalendarDate(caseData.incident_date)}` : ""}
  </span>
);

const RecordCounts = ({ title, records }) => (
  <section className="case-merge-preview-section">
    <h4>{title}</h4>
    {records?.length ? (
      <ul className="case-merge-preview-records">
        {records.map((record) => (
          <li className="info-color-panels-odd-even" key={record.model}>
            <span>{record.name}</span>
            <span className="case-merge-preview-count">({record.count})</span>
          </li>
        ))}
      </ul>
    ) : (
      <p className="text-primary-25">None.</p>
    )}
  </section>
);

const MergePreview = ({ confirmation, merging, onCancel, onMerge }) => {
  const preview = confirmation?.data;
  return (
    <Modal
      show={Boolean(preview)}
      onHide={onCancel}
      centered
      size="lg"
      contentClassName="custom-modal-new-provider"
      backdrop={merging ? "static" : true}
      keyboard={!merging}
      className="case-merge-preview"
      aria-labelledby="case-merge-preview-title"
    >
      <Modal.Header
        className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
        style={{ borderBottom: "none" }}
      >
        <Modal.Title
          id="case-merge-preview-title"
          className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
          style={{ fontSize: "14px", fontWeight: 600 }}
        >
          Confirm Case Merge
        </Modal.Title>
      </Modal.Header>
      {preview && (
        <Modal.Body className="p-0 m-t-5 m-l-5 m-r-5 m-b-5 background-div">
          <p className="case-merge-preview-question">
            Merge {preview.merged_cases.length}{" "}
            {preview.merged_cases.length === 1 ? "case" : "cases"} into{" "}
            <PreviewCase caseData={preview.target_case} />?
          </p>
          <div className="case-merge-preview-notice case-merge-preview-danger" role="alert">
            The checked cases will be permanently deleted after their records are merged. This
            cannot be undone.
          </div>
          <section className="case-merge-preview-section">
            <h4>Cases to Merge and Delete</h4>
            <ul className="case-merge-preview-records">
              {preview.merged_cases.map((caseData) => (
                <li className="info-color-panels-odd-even" key={caseData.id}>
                  <PreviewCase caseData={caseData} />
                </li>
              ))}
            </ul>
          </section>
          <p className="case-merge-preview-retained text-primary-25">
            The final case keeps its case type, incident date, file number, staff assignments, and
            status/stage. Unchecked cases are left alone.
          </p>
          <RecordCounts title="Moving" records={preview.moved} />
          <RecordCounts title="Removed with the Merged Cases" records={preview.removed} />
          {preview.warnings?.map((warning, index) => (
            <div
              className="case-merge-preview-notice case-merge-preview-warning"
              role="alert"
              key={`${warning.code}-${index}`}
            >
              {warning.message}
            </div>
          ))}
        </Modal.Body>
      )}
      <Modal.Footer
        className="p-0 mt-0 padding-outside-btn-new-provider justify-content-between"
        style={{ borderTop: "none" }}
      >
        <Button
          type="button"
          className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
          variant="secondary"
          onClick={onCancel}
          disabled={merging}
        >
          Cancel
        </Button>
        <Button
          type="button"
          className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
          variant="danger"
          onClick={onMerge}
          disabled={merging}
        >
          {merging ? "Merging…" : "Merge and Delete"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MergePreview;
